'use strict';

angular.module('rmOBA.02OrderDetails', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/02-order-details', {
    templateUrl: 'views/02OrderDetails/02OrderDetails.html'
});
}])


/**
* @memberof rmOBA
* @ngdoc controller
* @name 02OrderDetailsControl
* @param $scope {service} controller scope
* @param $location {service} Angular location service
* @param $modal {service} Angular Strap modal directive - Modals are streamlined, but flexible, dialog prompts with the minimum required functionality and smart defaults.
* @param rmUtils {service} General utilites used in this app
* @param rmState {service} State service for this app - Particularly navigation states
* @param rmResources {service} Resources service - group and individual functions to gather form data from converted json files
* @param rmUserPostalProductsData {service} Gather user created Order Lines data from local storage
* @description 
*   This is the second stage of completing the Emergency Order Form. This view shows list of created order lines within a table.
*/
.controller('02OrderDetailsCtrl', [ 
    '$scope', 
    '$location', 
    '$modal', 
    'rmUtils', 
    'rmState', 
    'rmResources',
    'rmUserPostalProductsData', function( 
        $scope,
        $location,
        $modal,
        rmUtils,
        rmState,
        rmResources, 
        rmUserPostalProductsData
    ) {

    $scope.orders = [];
    $scope.editingModal = false;
    $scope.editingModalIndex = null;

    // Go get previously saved orders if they exist
    var storedPostalProductData = rmUserPostalProductsData.get();
    if (!_.isEmpty(storedPostalProductData)) {
        $scope.orders = storedPostalProductData;
    }

    // Pre-fetch an external template populated with a custom scope
    var orderDetailsForm = $modal({scope: $scope, templateUrl: 'views/02OrderDetails/postageProductForm.modal.html', show: false, backdrop: 'static', });

    /**
    * @memberof 02OrderDetailsControl
    * @function addNewOrderLine
    * @desc Add a new order line
    */
    $scope.addNewOrderLine = function() {
        orderDetailsForm.$promise.then(orderDetailsForm.show);
    };

    $scope.enableEmailPrint = function() {
        if ($scope.orders.length > 0) {
            rmState.set('stage2Passed', true); // update the navigation.
        } else {
            rmState.set('stage2Passed', false); // update the navigation.
        }
    }

    /**
    * @memberof 02OrderDetailsControl
    * @function editOrderLine
    * @desc Edit the selected order line
    * @param {number} index The index of the selected order line
    */
    $scope.editOrderLine = function(index) {
        // get the model for this index...
        // pass this model to the modal
        $scope.editingModal = $scope.orders[index];
        $scope.editingModalIndex = index;
        orderDetailsForm.$promise.then(orderDetailsForm.show);
    }

    /**
    * @memberof 02OrderDetailsControl
    * @function deleteOrderLine
    * @desc Delete the selected order line
    * @param {number} index The index of the selected order line
    */
    $scope.deleteOrderLine = function(index) {
        if (window.confirm("This will delete this order line. Are you sure you want to continue?")) {
            $scope.orders.splice(index, 1);
            rmUserPostalProductsData.put($scope.orders);
        }
        $scope.enableEmailPrint();
    }

    /**
    * @memberof 02OrderDetailsControl
    * @function deleteAll
    * @desc Delete all order lines
    */
    $scope.deleteAll = function() {
        if (window.confirm("This will delete ALL order lines from your current order. Are you sure you want to continue?")) {
            $scope.orders = [];
            rmUserPostalProductsData.put($scope.orders);
        }
        $scope.enableEmailPrint();
    }

    /**
    * @memberof 02OrderDetailsControl
    * @function closeModal
    * @desc Close the add/edit orderline modal window
    */
    $scope.closeModal = function() {
        if ($scope.editingModal) {
            $scope.editingModal = false;
        }
        orderDetailsForm.hide();
        $scope.enableEmailPrint();
    }

    // Get the products to populate the select product dropdown.
    rmResources.getServicesData().then(function(data) {
      $scope.OBAservices = data.data;
    });


    /**
    * @memberof 02OrderDetailsControl
    * @function goToStage3
    * @desc Save the Order Lines and proceed to final stage 
    */
    $scope.goToStage3 = function() {
        rmUserPostalProductsData.put($scope.orders);
        rmState.set('stage2Passed', true); // update the navigation.
        $location.path('/03-email-and-print');
    }

    rmUtils.tealiumTagOverlay({
        "pageName": "RM Web App >OBA >Alternative Order Form> 2. Add order details",
        "pageMenuTree": "OBA|Alternative Order Form",
        "pageTemplate": "Form",
        "pageBreadCrumb": "Home|OBA|Alternative Order Form|2. Add order details",
        "pageApplicationStep": "2. Add order details"
    });

}])



/**
* @memberof rmOBA
* @ngdoc controller
* @name orderDetailsCtrl
* @param $scope {service} controller scope
* @param $modal {service} Angular Strap modal directive - Modals are streamlined, but flexible, dialog prompts with the minimum required functionality and smart defaults.
* @param rmUtils {service} General utilites used in this app
* @param rmResources {service} Resources service - group and individual functions to gather form data from converted json files
* @param rmUserPostalProductsData {service} Gather user created Order Lines data from local storage
* @description 
*   Within a modal window shows the Add New Postage Product Modal form
*/
.controller('orderDetailsCtrl', [
    '$scope',
    '$modal', 
    'rmUtils', 
    'rmResources',
    'rmUserPostalProductsData', function(
        $scope,
        $modal,
        rmUtils,
        rmResources,
        rmUserPostalProductsData
    ) {

    var _this = this;

    $scope.order = {};

    // Go get all of the products
    $scope.selectedProduct = { value: {} };
    rmResources.getServicesData().then(function(data) {
        $scope.products = data.data;
    });

    // Go get all of the lookups
    rmResources.getAllLookups().then(function(data) {
        $scope.lookUps = data;
        _this.createOrderModel();
    });


    /**
    * @memberof orderDetailsCtrl
    * @function createOrderModel
    * @desc Create the order model to bind all field values to. 
    * We loop through each Order Lines row in the Order Lines Table. Then create a new model for each row. 
    * This gives us a model to bind field values to. 
    * It also allows us to write to the model before editing so that the fields are persisted.
    */
    _this.createOrderModel = function() {
        // loop through orderlines table creating a model variable 
        // for each row.
        angular.forEach($scope.lookUps.orderLines, function(key, value) {
            $scope.order[key.Field]= null;

            // Set the regex pattern to validate this field
            if (key['Validation'].length > 0) {
                key.regex = rmUtils.getRegex(key['Validation']);
            }
        });

        if ($scope.editingModal) {
            // If editing an order line set the form 
            // model to that of the order to be edited
            $scope.order = angular.copy($scope.editingModal);
            $scope.selectedProduct = {value: {ID: $scope.editingModal['Product Code'],Value: $scope.editingModal['Product Name']}}
            return;
        }
        
        $scope.order['Product Name'] = $scope.selectedProduct.value.Value;
        $scope.order['Service Level'] = '01';
    }

    /**
    * @memberof orderDetailsCtrl
    * @function updateProduct
    * @desc Update the current product id in the model. 
    * Eg when changing the product ID from the product dropdown, or when editing an Order Line.
    */
    $scope.updateProduct = function() {
        if ($scope.editingModal) {
            if (window.confirm("This will delete this order line. Are you sure you want to continue?")) {
                $scope.orders.splice($scope.editingModalIndex, 1);
                rmUserPostalProductsData.put($scope.orders);
                $scope.editingModalIndex = null;
                $scope.editingModal = false;
            }
        }
        _this.createOrderModel();
        $scope.order['Product Code'] = $scope.selectedProduct.value.ID;
    }


    /**
    * @memberof orderDetailsCtrl
    * @function addPostageProduct
    * @desc Save the newly created, valid, Order Line.  
    * NB: this is different to savePostageProduct() in that it only shows when ADDING a NEW Order Line. 
    * It does not show when editing an Order Line.
    * @param {object} form The Angular Form object wrapping the trigger element
    */
    $scope.addPostageProduct = function(form) {
        if (form.$valid) {
            $scope.order.productName = $scope.selectedProduct.Value;
            $scope.orders.push($scope.order);
            rmUserPostalProductsData.put($scope.orders);
            $scope.closeModal();
        }
    }


    /**
    * @memberof orderDetailsCtrl
    * @function savePostageProduct
    * @desc Save an updated, valid, Order Line.  
    * NB: this is different to addPostageProduct() in that it only shows when EDITING an Order Line. 
    * It does not show when adding an Order Line.
    * @param {object} form The Angular Form object wrapping the trigger element
    */
    $scope.savePostageProduct = function(form) {
        // We are saving a previously created order line.
        if (form.$valid) {
            // remove the old orderline
            $scope.orders.splice($scope.editingModalIndex, 1);
            // place the new orderline where the old one was
            $scope.orders.splice($scope.editingModalIndex, 0, $scope.order);
            rmUserPostalProductsData.put($scope.orders);
            $scope.closeModal();
        }
    }

    $scope.submitForm = function(form) {
        if ($scope.editingModal) {
            $scope.savePostageProduct(form);
        } else {
            $scope.addPostageProduct(form);
        }
    }

}]);